import { createURL, userManager } from '../../config';
import { User } from '../types';

export interface Response {
  status: number;
  message?: string;
  user?: User;
}

export async function makeRequest(
  path: string,
  body?: any,
  method: 'GET' | 'POST' = 'POST',
): Promise<Response> {
  const oidcUser = await userManager.getUser();

  const headers = {
    // if a oidcUser is authenticated, add their token as an auth header
    ...(oidcUser && { Authorization: `Bearer ${oidcUser.access_token}` }),
    ...{
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  const req: RequestInit = {
    method,
    headers,
    credentials: 'same-origin',
  };

  if (method === 'POST') {
    req.body = JSON.stringify(body);
  }

  const res = await fetch(createURL(path), req);
  if (!res.ok) {
    const response: Response = {
      status: res.status,
      message: res.statusText,
    };

    return response;
  }

  if (res.status !== 200) {
    return { status: res.status };
  }

  const user: User = await res.json();
  return {
    status: res.status,
    message: res.statusText,
    user,
  };
}
